
<textarea
       [formControl]="control"
       [attr.placeholder]="placeholder"
       class="appearance-none w-full !outline-none text-sm placeholder-gray-400 !focus:outline-none rounded-lg bg-white px-4 py-3 border border-gray-200 transition-colors focus:border-primary-two">
</textarea>
